import { getByPath, stringifyData } from '@/utils/widgets';

/** Calculate whether a widget should be visible or not. */
export const isWidgetVisible = (dataValueByPath: unknown) => {
  if (
    dataValueByPath === undefined ||
    dataValueByPath === null ||
    (typeof dataValueByPath === 'string' && dataValueByPath.trim().length === 0)
  )
    return false;
  if (Array.isArray(dataValueByPath) && dataValueByPath.length === 0) {
    return false;
  }
  return true;
};

/**
 * Returns a value based on the provided data and a JMESPath.
 */
export const getTextData = (
  data: Record<string, unknown>,
  path: string,
  defaultValue?: string
) => {
  const textData = getByPath<string>(data, path);
  return stringifyData(textData, defaultValue);
};
